import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';

export const TrialSignupSteps: React.FC<{
  step: number;
  maxSteps: number;
}> = ({ step, maxSteps }) => (
  <div className="tw-mt-8">
    <div
      className={cs(
        'tw-mb-3',
        'tw-text-center',
        'tw-text-sm tw-text-primary-400'
      )}
    >
      Step {step} of {maxSteps}
    </div>
    <div className="tw-flex tw-flex-wrap tw-justify-between tw-gap-2">
      {Array.from(Array(maxSteps).keys()).map((i) => (
        <div
          key={i}
          className={cs(
            'tw-flex-grow',
            'tw-h-0 tw-rounded-full',
            'tw-border-b-4 tw-border-solid tw-border-b-neutral-200',
            {
              'tw-border-b-primary-400': step >= i + 1,
            }
          )}
        />
      ))}
    </div>
  </div>
);
